import { GridFields } from 'components';
import { formatToDate, formatWithGmtOffset } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import {
  Field,
  useFormContext,
} from 'modules/operation/common/forms/operationForm';
import { useOperationFormContentContext } from 'modules/operation/common/providers/OperationFormContentProvider';

import { Section } from '../../Section';

export const SettlementSection = () => {
  const { t } = useTranslation();

  const { readOnly, values } = useFormContext();

  const { brokerTimezoneOffset } = useOperationFormContentContext();

  const editable = !readOnly;

  return (
    <Section
      datax="operation-settlementSection"
      title={t('operation.sections.settlementSection.title')}
    >
      <GridFields>
        {editable ? (
          <Field.DatePicker
            showRequiredMark
            disableFuture={false}
            label={t(
              'operation.sections.settlementSection.fields.settlementDate.label'
            )}
            name="settlementDate"
            placeholder={t(
              'operation.sections.settlementSection.fields.settlementDate.placeholder'
            )}
          />
        ) : (
          <Input
            readOnly
            showCopyButton
            label={t(
              'operation.sections.settlementSection.fields.settlementDate.label'
            )}
            value={
              values.settlementDate
                ? formatWithGmtOffset(
                    values.settlementDate,
                    brokerTimezoneOffset,
                    formatToDate
                  )
                : ''
            }
          />
        )}

        <Field.Decimal
          label={t(
            'operation.sections.settlementSection.fields.exchangeRate.label'
          )}
          maxFloatingPoints={8}
          name="exchangeRate"
          placeholder={t(
            'operation.sections.settlementSection.fields.exchangeRate.placeholder'
          )}
        />
      </GridFields>
    </Section>
  );
};
